export default "__VITE_ASSET__DwbJki8q__"